import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './product-pattern-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.object
}

const defaultProps = {
  hiddenColumns : [],
  isLoading     : false
}

/**
 * Table to display Product Pattern columns
 * @param {Array<Object>} data - array of product patterns objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const ProductPatternTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  rowButtonProps
}) => {
  const {
    handleEnablePattern,
    handleDisablePattern,
    handleOpenUpdateModal
  } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    handleEnablePattern,
    handleDisablePattern,
    handleOpenUpdateModal
  }), [
    handleEnablePattern,
    handleDisablePattern,
    handleOpenUpdateModal
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

ProductPatternTable.propTypes    = propTypes
ProductPatternTable.defaultProps = defaultProps

export default ProductPatternTable